import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../../account/angular/models/account.model";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CustomersAlerts} from "../../services/customers-alerts.service";
import {CustomersDialogService} from "../../services/customers-dialogs-service.service";
import {CustomersRequests} from "../../services/customers-requests.service";
import {CustomerService} from "../../services/customers-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class customersViewCtrl implements IController {

  account: AccountModel;

  private accountIds: any;
  private doReload: any;
  private filtersConfig: any;

  /* @ngInject */
  constructor(private customersDialogService: CustomersDialogService, private customersRequests: CustomersRequests, private confirmDialogService: ConfirmDialogService,
              private bringozLoaderService: BringozLoaderService, private $log, private customersAlerts: CustomersAlerts, private $filter, private customerService: CustomerService) {
  }

  $onInit() {
    this.accountIds = this.account ? [this.account.id] : [];
    this.doReload = false;
    this.filtersConfig = {
      queryString: undefined,
    }
  }

  onAccountsChange(accountIds) {
    this.accountIds = accountIds;
    this.doReload = true;
  }

  submitQuery(query) {
    this.filtersConfig.queryString = query;
  }

  onReloadFinished() {
    this.doReload = false;
  }

  onCreateCustomer(event) {
    this.customersDialogService.createCustomer(event, undefined, this.account?.id)
      .then((customerToCreate) => {
        customerToCreate.phone = this.$filter('bringozPhonePrefix')(customerToCreate.phone);
        this.bringozLoaderService.on();
        return this.customersRequests.createCustomer(customerToCreate)
      })
      .then((createdCustomer) => {
        this.doReload = true;
        this.customersAlerts.createSuccess();
      })
      .catch((error) => {
        if (error) {
          this.customersAlerts.createError();
          this.$log.error('Failed to create customer @customersView@onCreateCustomer', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onDeleteCustomer(customer, event) {
    let isDeleting = false;
    const text = 'Are you sure you want to delete this customer?';
    this.confirmDialogService.confirmMask('Delete Customer', text, event)
      .then((shouldMask) => {
        isDeleting = true;
        this.bringozLoaderService.on();
        return this.customersRequests.deleteCustomer(customer.id, shouldMask)
      })
      .then((res) => {
        this.doReload = true;
        this.customersAlerts.deleteOneSuccess(customer);
      })
      .catch((error) => {
        if (error) {
          this.customersAlerts.deleteOneError();
          this.$log.error('Failed to delete customer @customersView@onDeleteCustomer', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (isDeleting) {
          this.bringozLoaderService.off();
        }
      })
  }

  onEdit(customer, event) {
    this.customersDialogService.editCustomer(event, customer)
      .then((customerToUpdate) => {
        this._updateCustomer(customerToUpdate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onExport($event, exportType) {
    this.customerService.export(
      exportType,
      this.accountIds,
    );
  }

  private _updateCustomer(customer) {
    this.customerService.updateCustomer(customer);
  }

}

angular
  .module('bringoz.admin.customers')
  .component('customersView', {
    bindings: {
      account: '<?'
    },
    template: require('./customers-view.html').default,
    controller: customersViewCtrl
  });
